/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcenterenabled2Inputs */

const en_entity_contactcenterenabled2 = /** @type {(inputs: Entity_Contactcenterenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Center Enabled`)
};

const de_entity_contactcenterenabled2 = /** @type {(inputs: Entity_Contactcenterenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Center aktiviert`)
};

/**
* | output |
* | --- |
* | "Contact Center Enabled" |
*
* @param {Entity_Contactcenterenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcenterenabled2 = /** @type {((inputs?: Entity_Contactcenterenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcenterenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcenterenabled2(inputs)
	return de_entity_contactcenterenabled2(inputs)
});
export { entity_contactcenterenabled2 as "entity_contactCenterEnabled" }